import React, { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { AdminRoute, StudentRoute, CommonRoute as CmnRoute } from './Helper';
import { fronturls } from '../constants/FrontendURLs';
import LayoutStructure from '../components/Layout';
import PageNotFound from '../pages/common/PageNotFound';
import constants from '../constants/Constants';
import JsonResponseData from '../pages/admin/JsonInfo/JsonResponseData';
// Lazy load components
const MyScores = lazy(() => import('../pages/student/MyScores'));
const Registration = lazy(() => import('../pages/common/Registration'));
const VideoPreview = lazy(() => import('../pages/student/Video/VideoPreview'));
const ImageUpdate = lazy(() => import('../pages/admin/Images/ImageUpdate'));
const InvalidBookCode = lazy(() => import('../pages/common/FAQs/InvalidBookCode'));
const AccessResources = lazy(() => import('../pages/common/FAQs/AccessResources'));
const FindAccessCode = lazy(() => import('../pages/common/FAQs/FindAccessCode'));
const UseMyCode = lazy(() => import('../pages/common/FAQs/UseMyCode'));
const DidNotReceiveRegistrationMail = lazy(() => import('../pages/common/FAQs/DidNotReceiveRegistrationMail'));
const NotReceivingMails = lazy(() => import('../pages/common/FAQs/NotReceivingMails'));
const ForgottenUsernamePassword = lazy(() => import('../pages/common/FAQs/ForgottenUsernamePassword'));
const AccAccessInfo = lazy(() => import('../pages/common/FAQs/AccAccessInfo'));
const CannotAccessOnlineResources = lazy(() => import('../pages/common/FAQs/CannotAccessOnlineResources'));
const UniversityListing = lazy(() => import('../pages/admin/Universities/UniversityListing'));
const AddUniversity = lazy(() => import('../pages/admin/Universities/AddUniversity'));
const CannotLoginAccount = lazy(() => import('../pages/common/FAQs/CannotLoginAccount'));
const CodesListing = lazy(() => import('../pages/admin/Codes/CodesListing'));
const AddImageQuiz = lazy(() => import('../pages/admin/ImageQuiz/AddImageQuiz'));
const Documents = lazy(() => import('../pages/admin/Documents/Documents'));
const DocView = lazy(() => import('../pages/common/DocView'));
const ImageQuizScores = lazy(() => import('../pages/admin/ImageQuiz/ImageQuizScores'));
const Policies = lazy(() => import('../pages/common/Policies'));
const Home = lazy(() => import('../pages/common/Home'));
const Login = lazy(() => import('../pages/common/Login'));
const ForgotPassword = lazy(() => import('../pages/common/ForgotPassword'));
const ResetPassword = lazy(() => import('../pages/common/ResetPassword'));
const StudentDashboard = lazy(() => import('../pages/student/Dashboard'));
const AdminDashboard = lazy(() => import('../pages/admin/Dashboard'));
const ContactUs = lazy(() => import('../pages/common/ContactUs'));
const TakeTest = lazy(() => import('../pages/student/Tests/TakeTest'));
const Instructions = lazy(() => import('../pages/student/Tests/Instructions'));
const Listing = lazy(() => import('../pages/common/Listing'));
const FlashcardQuestions = lazy(() => import('../pages/admin/Flashcard/FlashcardQuestions'));
const FlashcardView = lazy(() => import('../pages/student/Flashcard/FlashcardView'));
const Codes = lazy(() => import('../pages/admin/Codes/Codes'));
const QuestionListing = lazy(() => import('../pages/admin/Questions/QuestionListing'));
const Acknowledgements = lazy(() => import('../pages/common/Acknowledgements'));
const Help = lazy(() => import('../pages/common/Help'));
const Feedback = lazy(() => import('../pages/student/Feedback'));
const UserList = lazy(() => import('../pages/common/UserList'));
const EditUsers = lazy(() => import('../pages/common/EditUsers'));
const Activation = lazy(() => import('../pages/common/Activation'));
const IQInstructions = lazy(() => import('../pages/student/imageQuiz/IQInstructions'));
const UpdateImageQuiz = lazy(() => import('../pages/admin/ImageQuiz/UpdateImageQuiz'));
const QuestionUpdate = lazy(() => import('../pages/admin/Questions/QuestionUpdate'));
const TestScore = lazy(() => import('../pages/admin/Tests/TestScore'));
const ImageQuiz = lazy(() => import('../pages/student/imageQuiz/ImageQuiz'));
const ResultPage = lazy(() => import('../pages/student/Tests/ResultPage'));
const ReviewIncorrect = lazy(() => import('../pages/student/Tests/ReviewTest'));
const ImageQuizReviewIncorrect = lazy(() => import('../pages/student/imageQuiz/ReviewIncorrect'));
const ViewPdf = lazy(() => import('../pages/student/ViewPdf'));
const ResendActivation = lazy(() => import('../pages/student/ResendActivation'));
const Profile = lazy(() => import('./../pages/common/Profile'));
const EditFlashcard = lazy(() => import('../pages/admin/Flashcard/EditFlashcard'));
const VideoEdit = lazy(() => import('../pages/admin/Video/VideoEdit'));
const Settings = lazy(() => import('../pages/admin/Settings/Settings'));
const Crons = lazy(() => import('../pages/admin/Crons/Crons'));
const FlashcardAnalysis = lazy(() => import('../pages/admin/Flashcard/FlashcardAnalysis'));

const CommonRoute = (pathname, component) => {
  return <Route path={pathname} element={<Suspense>{component}</Suspense>} />
}

const routerBrowser = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path={fronturls.ViewPdf} element={<ViewPdf />} />
      <Route path={fronturls.ViewDocument} element={<DocView />} />
      <Route element={<LayoutStructure />}>
        {/* Common routes */}
        <Route path="/" element={<Home />} />
        <Route path="*" element={<PageNotFound />} />
        {CommonRoute(fronturls.Home, <Home />)}
        {CommonRoute(fronturls.StudentLogin, <Login />)}
        {CommonRoute(fronturls.AdminLogin, <Login />)}
        {CommonRoute(fronturls.ForgotPassword, <ForgotPassword />)}
        {CommonRoute(fronturls.ResetPassword, <ResetPassword />)}
        {CommonRoute(fronturls.Registration, <Registration />)}
        {/* {CommonRoute(fronturls.MyProfile, <CommonRoute><Profile /></CommonRoute>)} */}
        {CommonRoute(fronturls.Acknowledgements, <Acknowledgements />)}
        {CommonRoute(fronturls.Help, <Help />)}
        {CommonRoute(fronturls.ContactUs, <ContactUs />)}
        {CommonRoute(fronturls.Activation, <Activation />)}
        {CommonRoute(fronturls.ResendEmail, <ResendActivation />)}
        {CommonRoute(fronturls.InvalidBookCode, <InvalidBookCode />)}
        {CommonRoute(fronturls.AccessOnlineResources, <AccessResources />)}
        {CommonRoute(fronturls.FindAccessCode, <FindAccessCode />)}
        {CommonRoute(fronturls.UseMyCode, <UseMyCode />)}
        {CommonRoute(fronturls.DidNotReceiveMail, <DidNotReceiveRegistrationMail />)}
        {CommonRoute(fronturls.NotReceiveMails, <NotReceivingMails />)}
        {CommonRoute(fronturls.ForgottenUsernamePassword, <ForgottenUsernamePassword />)}
        {CommonRoute(fronturls.AccAccessInfo, <AccAccessInfo />)}
        {CommonRoute(fronturls.CannotAccessOnlineResources, <CannotAccessOnlineResources />)}
        {CommonRoute(fronturls.CannotLoginAccount, <CannotLoginAccount />)}
        {CommonRoute(fronturls.Policies, <Policies />)}
        {/*  */}
        {/* Protected Routes for Students to be entered here */}
        <Route path={fronturls.Instructions} element={<StudentRoute><Instructions /></StudentRoute>} />
        <Route path={fronturls.StudentDashboard} element={<StudentRoute><StudentDashboard /></StudentRoute>} />
        <Route path={fronturls.FlashcardView} element={<StudentRoute><FlashcardView /></StudentRoute>} />
        <Route path={fronturls.MyScores} element={<StudentRoute><MyScores /></StudentRoute>} />
        <Route path={fronturls.VideoPreview} element={<CmnRoute><VideoPreview /></CmnRoute>} />
        <Route path={fronturls.StartTest} element={<StudentRoute><TakeTest /></StudentRoute>} />
        <Route path={fronturls.ResumeTest} element={<StudentRoute><TakeTest /></StudentRoute>} />
        <Route path={fronturls.Feedback} element={<StudentRoute><Feedback /></StudentRoute>} />
        <Route path={fronturls.ImageQuizInstruction} element={<StudentRoute><IQInstructions /></StudentRoute>} />
        <Route path={fronturls.RetakeTest} element={<StudentRoute><TakeTest /></StudentRoute>} />
        <Route path={fronturls.ImageQuiz} element={<CmnRoute><ImageQuiz /></CmnRoute>} />
        {/*  */}
        {/* Protected Routes for Admin to be entered here */}
        <Route path={fronturls.AdminDashboard} element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path={fronturls.CodeGeneration} element={<AdminRoute><Codes /></AdminRoute>} />
        <Route path={fronturls.QuestionListing} element={<AdminRoute><QuestionListing /></AdminRoute>} />
        <Route path={fronturls.FlashcardQuestions} element={<AdminRoute><FlashcardQuestions /> </AdminRoute>} />
        <Route path={fronturls.EditUser} element={<AdminRoute><EditUsers /></AdminRoute>} />
        <Route path={fronturls.AdminUsers} element={<AdminRoute><UserList /></AdminRoute>} />
        <Route path={fronturls.StudentUsers} element={<AdminRoute><UserList /></AdminRoute>} />
        <Route path={fronturls.QuestionUpdate} element={<AdminRoute><QuestionUpdate /></AdminRoute>} />
        <Route path={fronturls.ImageQuizUpdate} element={<AdminRoute><UpdateImageQuiz /></AdminRoute>} />
        <Route path={fronturls.TestScore} element={<AdminRoute><TestScore /></AdminRoute>} />
        <Route path={fronturls.ImageUpdate} element={<AdminRoute><ImageUpdate /></AdminRoute>} />
        <Route path={fronturls.EditFlashcard} element={<AdminRoute><EditFlashcard /></AdminRoute>} />
        <Route path={fronturls.AddFlashcard} element={<AdminRoute><EditFlashcard /></AdminRoute>} />
        <Route path={fronturls.UniversityListing} element={<AdminRoute><UniversityListing /></AdminRoute>} />
        <Route path={fronturls.AddUniversity} element={<AdminRoute><AddUniversity /></AdminRoute>} />
        <Route path={fronturls.VideoEdit} element={<AdminRoute><VideoEdit /></AdminRoute>} />
        <Route path={fronturls.CodesListing} element={<AdminRoute><CodesListing /></AdminRoute>} />
        <Route path={fronturls.AddImageQuiz} element={<AdminRoute><AddImageQuiz /></AdminRoute>} />
        <Route path={fronturls.AddQuestion} element={<AdminRoute><QuestionUpdate /></AdminRoute>} />
        <Route path={fronturls.DocumentsListing} element={<AdminRoute><Documents /></AdminRoute>} />
        <Route path={fronturls.ImageQuizScores} element={<AdminRoute><ImageQuizScores /></AdminRoute>} />
        <Route path={fronturls.Settings} element={<AdminRoute><Settings /></AdminRoute>} />
        <Route path={fronturls.CronActivity} element={<AdminRoute><Crons /></AdminRoute>} />
        <Route path={fronturls.Responsedata} element={<AdminRoute><JsonResponseData /></AdminRoute>} />
        <Route path={fronturls.FlashcardAnalysis} element={<AdminRoute><FlashcardAnalysis /></AdminRoute>} />

        <Route path={fronturls.Flashcards} element={<CmnRoute><Listing /></CmnRoute>} />
        <Route path={fronturls.Images} element={<CmnRoute><Listing /></CmnRoute>} />
        <Route path={fronturls.Videos} element={<CmnRoute><Listing /></CmnRoute>} />
        <Route path={fronturls.ImageQuizzes} element={<CmnRoute><Listing /></CmnRoute>} />
        <Route path={fronturls.Tests} element={<CmnRoute><Listing /></CmnRoute>} />
        <Route path={fronturls.MyProfile} element={<CmnRoute><Profile /></CmnRoute>} />
        <Route path={fronturls.TestResult} element={<CmnRoute><ResultPage /></CmnRoute>} />
        <Route path={fronturls.ReviewIncorrect} element={<CmnRoute><ReviewIncorrect /></CmnRoute>} />
        <Route path={fronturls.ReviewAll} element={<CmnRoute><ReviewIncorrect /></CmnRoute>} />
        <Route path={fronturls.ImageQuizResults} element={<CmnRoute><ResultPage /></CmnRoute>} />
        <Route path={fronturls.IQReviewIncorrect} element={<CmnRoute><ImageQuizReviewIncorrect /></CmnRoute>} />
        {/* Common routes for student and admin */}
        {/* <Route path={fronturls.Videos} element={<Suspense><ConditionalLayout /></Suspense>}>
          <Route index element={<Listing />} />
        </Route>
        <Route path={fronturls.ImageQuizzes} element={<Suspense><ConditionalLayout /></Suspense>}>
          <Route index element={<Listing />} />
        </Route>
        <Route path={fronturls.Tests} element={<Suspense><ConditionalLayout /></Suspense>}>
          <Route index element={<Listing />} />
        </Route> */}
        {/*  */}
      </Route>
    </>
  ),
  {
    basename: constants.BaseUrl,
  }
);
export default routerBrowser;
